import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import Internal from "components/menu/file-manager/internal";
import Ume from "components/menu/file-manager/ume";

const FileManagerRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/internal`}
                component={Internal}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/ume`}
                component={Ume}
            />
        </Switch>
    </div>
);

export default connect()(FileManagerRouter);
